import Typography from '@mui/material/Typography';
import ItemButton from '../../../../shared/ItemButton';
import { ReactComponent as QuestionIcon } from '../../../../../images/question.svg';
import { ReactComponent as Report } from '../../../../../images/report.svg';
import { customEventTracking } from '../../../../../lib/gtm';
import Box from '@mui/material/Box';
import { Divider } from '../../../../shared/Divider';
import { RootState } from '../../../../../store';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useState } from 'react';
import ModalComponent from './Modal';
import { usePatientCare } from './hooks';

const PatientCare = () => {
  const { journey } = useSelector((state: RootState) => state);
  const [openModal, setOpenModal] = useState(false);
  const {
    attendance: { hasConfirmed, confirmedSchedules }
  } = usePatientCare(journey);

  const handleToggleModal = () => {
    setOpenModal(prev => !prev);
  };

  const handlerKnowMoreClick = () => {
    process.env.REACT_APP_SITE_URL && window.open(process.env.REACT_APP_SITE_URL + '/sobre/perguntas-frequentes', '_blank');
    return false;
  };

  return (
    <>
      <Typography variant="body1B" sx={{ mb: 1 }}>
        Atendimento à oyana
      </Typography>

      <ItemButton
        text="Acessar perguntas frequentes"
        icon={
          <Box sx={{ marginRight: 2 }}>
            <QuestionIcon />
          </Box>
        }
        onClick={() => {
          handlerKnowMoreClick();
          customEventTracking.send({
            event: 'perguntas_frequentes_mc'
          });
        }}
      />

      <ItemButton
        disabled={!hasConfirmed}
        text="Declaração de Comparecimento"
        subText={!hasConfirmed ? 'Será habilitada após a confirmação do atendimento.' : ''}
        icon={
          <Box sx={{ marginRight: 2 }}>
            <Report />
          </Box>
        }
        onClick={() => {
          handleToggleModal();
          customEventTracking.send({
            event: 'declaracao_comparecimento_mc'
          });
        }}
      />
      <ModalComponent open={openModal} onFinished={handleToggleModal} schedules={confirmedSchedules} />
      <Divider />

      <Typography sx={{ mb: 2 }}>Entre em contato com nossa equipe de atendimento em horário comercial.</Typography>

      <Button
        variant="inline"
        color="primary"
        href={process.env.REACT_APP_WHATSAPP}
        target="_blank"
        component="a"
        endIcon={<WhatsAppIcon />}
      >
        Falar com Equipe de Cuidados
      </Button>
    </>
  );
};

export default PatientCare;
